import React, { memo, useState, useCallback, useRef } from 'react';
import t from 'common/i18n';
import PreviewInfo, { POSITION } from 'root/components/PreviewInfo';

import './PurchasePreview.scss';

const ID_STRIPE_HEIGHT = 30;

const PurchasePreview = (props) => {
  const [imageState, setImageState] = useState([null, null]);
  const imageRef = useRef();
  const [isLoading, setIsLoading] = useState(true);

  const onImageLoad = useCallback(() => {
    if (imageRef.current) {
      setImageState([imageRef.current.clientWidth, imageRef.current.clientHeight]);
    }

    assetLoaded();
  }, [imageRef]);

  const assetLoaded = () => setIsLoading(false);

  const imageSize = [imageState[0] ? imageState[0] : '100%', imageState[1] ? imageState[1] - ID_STRIPE_HEIGHT : 'auto'];

  const info = {
    ...props.asset,
    link: props.asset.preview_link ?? props.asset.link,
    title: t('shutterstock.purchase_preview.open_in_new_window'),
    subtitle: '',
    duration: '',
  };

  return props.asset ? (
    <section className="purchase-preview-page flex flex-column justify-center items-center flex-shrink-0 w-100 w-55-ns h-100-ns">
      {isLoading && (
        <h2 className="delay-display bg-source-bg-c">
          {t('shutterstock.purchase_preview.loading_preview')}
          <div className="ellipsis-container">
            <span className="loading" />
          </div>
        </h2>
      )}
      <div className="w-100 h-100 flex flex-column justify-center items-center" style={{ display: `${isLoading ? 'none' : 'flex'} ` }}>
        <div
          className="overflow-hidden w-100 h-100 text-center relative asset-container"
          style={{
            width: imageSize[0],
            height: imageSize[1],
          }}
        >
          {props.isVideo ? (
            <video className="preview" controls onCanPlay={assetLoaded}>
              <source src={props.asset.link} type="video/mp4" />
            </video>
          ) : (
            <img
              className="preview mw-100 mh-100"
              src={props.asset.link}
              onLoad={onImageLoad}
              style={{
                maxHeight: imageState[1] ? 'initial' : '100%',
              }}
              ref={imageRef}
            />
          )}
          <PreviewInfo {...info} position={POSITION.TOP} />
        </div>
      </div>
    </section>
  ) : null;
};

export default memo(PurchasePreview);
